import { render } from "./ZirconiaToothInfoForm.vue?vue&type=template&id=d10f0e8e&scoped=true"
import script from "./ZirconiaToothInfoForm.vue?vue&type=script&lang=js"
export * from "./ZirconiaToothInfoForm.vue?vue&type=script&lang=js"

import "./ZirconiaToothInfoForm.vue?vue&type=style&index=0&id=d10f0e8e&lang=scss"
import "./ZirconiaToothInfoForm.vue?vue&type=style&index=1&id=d10f0e8e&scoped=true&lang=scss"
import "./ZirconiaToothInfoForm.vue?vue&type=style&index=2&id=d10f0e8e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d10f0e8e"]])

export default __exports__